import { render, staticRenderFns } from "./OrderAsterisk.vue?vue&type=template&id=4852d56a"
import script from "./OrderAsterisk.vue?vue&type=script&lang=js"
export * from "./OrderAsterisk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports